import { render, staticRenderFns } from "./Masini_dialog.vue?vue&type=template&id=0f2a6838&scoped=true"
import script from "./Masini_dialog.vue?vue&type=script&lang=js"
export * from "./Masini_dialog.vue?vue&type=script&lang=js"
import style0 from "./Masini_dialog.vue?vue&type=style&index=0&id=0f2a6838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a6838",
  null
  
)

export default component.exports